import { render, staticRenderFns } from "./CompanyMenuVersionAccess.vue?vue&type=template&id=6f0b9e18&scoped=true"
import script from "./CompanyMenuVersionAccess.vue?vue&type=script&lang=js"
export * from "./CompanyMenuVersionAccess.vue?vue&type=script&lang=js"
import style0 from "./CompanyMenuVersionAccess.vue?vue&type=style&index=0&id=6f0b9e18&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0b9e18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0b9e18')) {
      api.createRecord('6f0b9e18', component.options)
    } else {
      api.reload('6f0b9e18', component.options)
    }
    module.hot.accept("./CompanyMenuVersionAccess.vue?vue&type=template&id=6f0b9e18&scoped=true", function () {
      api.rerender('6f0b9e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/onboarding/CompanyMenuVersionAccess.vue"
export default component.exports